import { useEffect, useRef } from 'react';

import { reportWarnings } from '@/features/app/MessageHandler';
import { useGetVehicleWarningSummaryQuery } from '@/services/warningsApi';

/**
 * Reports the vehicle's warning count to the parent frontend (web-workshop) via postMessage,
 * so it can enable/disable the "Repair Warnings" view.
 */
export const useReportWarnings = (assetId: string | undefined) => {
    const { data, isSuccess } = useGetVehicleWarningSummaryQuery({ assetId }, { skip: !assetId });

    const lastReported = useRef<number>();

    useEffect(() => {
        if (!isSuccess || !data) {
            return;
        }
        const count = data.schedule_service + data.service_soon + data.information;
        if (lastReported.current === count) {
            return;
        }
        lastReported.current = count;
        reportWarnings({ count });
    }, [assetId, isSuccess, data]);
};
